import { AdminService } from "src/services/AdminService";
import { Link, navigate } from "gatsby";
import Loading from "src/components/General/Loading";
import { ManageProfileModel } from "ps-shared";
import React from "react";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { Button, Col, Row, Container, Alert } from "reactstrap";

import { CognitoStore } from "src/stores/cognito-store";
import { CognitoSession } from "src/models/CognitoSession";

import { Faq } from "../Components/Faq/Faq";
import { SlackLatest } from "../Components/SlackLatest";
import { Invite } from "../Components/Invite";
import { DashboardGraphs } from "../Components/Graphs/DashboardGraphs";
import { ProfessionalConnect } from "../Components/ProfessionalConnect/ProfessionalConnect";
import { Account } from "../Components/Account/Account";

interface ManageProfilesProps {
  data: ManageProfileModel[];
  session: CognitoSession;
}
interface ManageProfilesState {
  loading: boolean;
  profiles: ManageProfileModel[];
  hasPractionerProfile: boolean;
  session: CognitoSession;
}

export class ManageProfilesComponent extends React.Component<ManageProfilesProps, ManageProfilesState> {
  // datatable columns
  private dtcolumns = [
    {
      name: "Profile Id",
      selector: "slug",
      sortable: true,
    },
    {
      name: "Profile Type",
      selector: "profileType",
      sortable: true,
    },
    {
      name: "Version",
      selector: "ver",
      sortable: true,
      cell: (row: any) => (
        <div>
          {row.ver === "published" && (
            <div
              onClick={(): void => {
                this.unpublishProfile(row);
              }}
              className="cursor-pointer"
            >
              <span className="me-2">{row.ver}</span>
              <FontAwesomeIcon icon={faPencilAlt} />
            </div>
          )}
          {row.ver !== "published" && <>{row.ver}</>}
        </div>
      ),
      ignoreRowClick: true,
    },
    {
      allowOverflow: true,
      button: true,
      cell: (row: any) => (
        <>
          <Button onClick={() => this.editProfile(row)}>Edit</Button>
        </>
      ),
      ignoreRowClick: true,
      name: "",
    },
    {
      allowOverflow: true,
      button: true,
      cell: (row: any) => (
        <>
          {row.ver === "published" && (
            <>
              <Button
                style={{ whiteSpace: "nowrap" }}
                color="primary"
                className="view"
                href={`${row.profileType === "community" ? "/community/" : "/network/"}${row.slug}/`}
                target="_blank"
              >
                View
              </Button>
            </>
          )}
          {row.ver !== "published" && (
            <Button color="primary" style={{ whiteSpace: "nowrap" }} onClick={() => this.previewProfile(row)}>
              Preview
            </Button>
          )}
        </>
      ),
      ignoreRowClick: true,
      name: "",
    },
  ];

  constructor(props: ManageProfilesProps) {
    super(props);
    this.state = {
      loading: false,
      profiles: [],
      hasPractionerProfile: true,
      session: null,
    };
    this.editProfile = this.editProfile.bind(this);
    this.previewProfile = this.previewProfile.bind(this);
    this.addClinic = this.addClinic.bind(this);
    this.addPractitioner = this.addPractitioner.bind(this);
    this.addCommunity = this.addCommunity.bind(this);
    this.loadProfiles = this.loadProfiles.bind(this);
    this.unpublishProfile = this.unpublishProfile.bind(this);
  }

  public componentDidMount() {
    this.setState({
      loading: true,
    });
    CognitoStore.userSession()
      .then((session) => {
        return this.setState({
          session,
        });
      })
      .catch((error) => {
        console.error(error);
        console.log("unable to get session!");
      });
    this.loadProfiles();
  }

  public loadProfiles(): void {
    AdminService.getAdminProfiles(this.props.session.username)
      .then((data: ManageProfileModel[]) => {
        this.setState({
          loading: false,
        });
        return this.setState({
          loading: false,
          profiles: data,
          hasPractionerProfile: data.filter((ap: ManageProfileModel) => ap.profileType === "practitioner").length > 0,
        });
      })
      .catch((error: any) => {
        console.log(error);
        this.setState({
          loading: false,
        });
        if (error.response.status === 404) {
          console.error("no profiles found!");
          // based on the user type, show options
        }
      });
  }

  public unpublishProfile(row: ManageProfileModel): void {
    // eslint-disable-next-line no-alert
    if (window.confirm("Are you sure you want to un-publish this profile?")) {
      // do the unpub
      this.setState({
        loading: true,
      });
      AdminService.unpublishProfile(row.slug)
        .then(() => {
          return this.loadProfiles();
        })
        .catch((error) => {
          // eslint-disable-next-line no-alert
          alert("Unable to un-publish this profile!");
          console.error(error);
        });
    }
  }

  public editProfile(row: ManageProfileModel) {
    navigate(`/my/profiles/${row.slug}/`);
  }

  public previewProfile(row: ManageProfileModel) {
    navigate(`/my/profiles/${row.slug}/preview/`);
  }

  public addClinic() {
    navigate("/my/profiles/new/clinic/");
  }

  public addPractitioner() {
    navigate("/my/profiles/new/practitioner/");
  }

  public addCommunity() {
    navigate("/my/profiles/new/community/");
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <Container className="manage-profiles ">
        {/*
                <Calendars />
        */}
        <Row className="mt-4">
          <Col>
            <h4 className="cta fw500">Hello {this.state.session?.firstName}</h4>
            <div className="mt-1">
              Thank you for being part of Psychedelic Support! Feel free to reach out to us with the chatbot at bottom
              right or <a href="mailto:info@psychedelic.support">email us.</a>
              <Faq groups={this.props.session.groups}></Faq>
              <div className="pt-5 ">
                <Alert className="alert alert-info ">
                  <Link to="/pricing/">
                    <div style={{ color: "#fff", fontWeight: "400" }}>
                      Did you know Psychedelic Support can help you <b>grow your practice</b> with our tools and
                      subscriptions? <b>Click here to learn more</b>
                    </div>
                  </Link>
                </Alert>
              </div>
            </div>
          </Col>
        </Row>
        <DashboardGraphs />
        <Row className="mt-5">
          <Col xs="12">
            <h5 className="underline cta fw400">Manage Profiles</h5>
          </Col>
        </Row>
        <Row className="mt-2 mb-5 pb-5">
          <Col xs="12">
            {this.state.loading && <Loading />}
            {!this.state.loading && (
              <>
                {this.state.profiles.some((p) => p.profileType === "practitioner") && (
                  <ProfessionalConnect
                    pcOptin={this.state.profiles.find((p) => p.profileType === "practitioner").pc}
                    pcSlug={this.state.profiles.find((p) => p.profileType === "practitioner").slug}
                  />
                )}
                {this.state.profiles && this.state.profiles.length >= 1 && (
                  <div>
                    <DataTable
                      noHeader={true}
                      columns={this.dtcolumns}
                      data={this.state.profiles}
                      defaultSortField="firstName"
                      className="mp-datatable"
                    />
                    <div className="mt-3 mb-5" style={{ textAlign: "center" }}>
                      <Invite session={this.props.session} />
                    </div>
                  </div>
                )}
                <Row className="mt-3">
                  <Col>
                    <div id="tour-add-profile" style={{ display: "inline-block" }}>
                      {this.props.session.groups.includes("provider") && this.state.hasPractionerProfile !== true && (
                        <Button className="me-1" onClick={() => this.addPractitioner()}>
                          Add Practitioner
                        </Button>
                      )}
                      {this.props.session.groups.includes("provider") && (
                        <Button className="me-1" onClick={() => this.addClinic()}>
                          Add Clinic
                        </Button>
                      )}
                      <Button onClick={() => this.addCommunity()}>Add Community Group</Button>
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>

        {this.props.session.groups.includes("provider") && <SlackLatest />}
        <Account />
      </Container>
    );
  }
}
